import styled from "styled-components";

export const VideoTileFooterDefaultBox = styled.div`
    display: flex;
    position: relative;
    padding: 2rem 1rem;
    align-items: center;
    justify-content: space-between;
    background: ${({theme}) => theme.colors.backgroundLight.toString()};

    @media ${({theme}) => theme.mediaQuery.xlAndAbove } {
        padding: 3rem 2.5rem;
    }

    &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        left: 0;
        bottom: 0;
        background: linear-gradient(90deg, transparent 10%, rgba(255, 255, 255, 0.85), transparent 90%);
    }
`;
